module.exports = __webpack_public_path__ + "static/media/goldHAt.06e6526f.jpeg";